import { createSelector } from 'reselect';

export const getSuggestedItems = (state) => state.suggestedItems.data;
export const getSuggestedItemsLoadingState = (state) => state.suggestedItems.loading;

export const getSuggestedItemsOptions = createSelector(
  getSuggestedItems,
  (items) => items.map(({ id, name, type }) => ({ id, name, type })),
);
